<div class="upload-progress-container">
  @if(currentStep === 5){
  <!--  -->
  @if(!runCoaMappingLoading){
  <app-custom-motif-uploader
    [file]="coaMappingFile"
    [dropMessage]="'Optionally, Click to upload or drag and drop'"
    (fileEmitter)="onCoaMappingFileUpload($event)"
    (fileHasError)="onCoaMappingFileHasErrorHasError($event)"
  ></app-custom-motif-uploader>
  } @if(runCoaMappingLoading){
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [hideLabel]="true"
      [isIndeterminate]="true"
      [tabIndex]="0"
    ></motif-progress-bar>
    <p progressbar-label>Level 1 of Chart of Account Mapping in progress...</p>

    <p
      class="cancel-run"
      [tabIndex]="0"
      (click)="cancelLatestMappingRun()"
      (keydown.enter)="cancelLatestMappingRun()"
    >
      Cancel
    </p>
  </div>
  }

  <div class="buttons-container">
    <motif-button
      variant="primary-alt"
      [disabled]="runCoaMappingLoading"
      (click)="goBackToAgentOne()"
    >
      Go back
    </motif-button>

    <motif-button
      variant="primary"
      [disabled]="runCoaMappingLoading || coaMappingFileHasError"
      (click)="runLatestMapping()"
    >
      Run
    </motif-button>
  </div>
  }
  <!--  -->
  @if(currentStep === 6){
  <div class="process-message-container" *ngIf="stepFiveDuration">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ stepFiveDuration }}</p>
  </div>

  <app-custom-motif-downloader
    [filename]="coaMappedFileToDownload.filename"
    [fileId]="coaMappedFileToDownload.id"
    [fileSize]="coaMappedFileToDownload.file_size"
  ></app-custom-motif-downloader>

  <div class="buttons-container">
    <motif-button
      variant="primary-alt"
      (click)="goToPreviousStep_5()"
    >
      Go back
    </motif-button>
    <motif-button
      variant="primary"
      (click)="goToNextStep(true)"
    >
      Next
    </motif-button>
  </div>
  }
  <!---->
  @if(currentStep === 7){
  <!---->
  @if(!runCoAFinalMapLoading){
  <app-custom-motif-uploader
    [file]="coaFinalMappingFile"
    [dropMessage]="'Optionally, Click to upload or drag and drop'"
    (fileEmitter)="onCoaFinalMappingFileUpload($event)"
    (fileHasError)="onCoaFinalMappingFileFileHasError($event)"
  ></app-custom-motif-uploader>
  } @if(runCoAFinalMapLoading){
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [hideLabel]="true"
      [isIndeterminate]="true"
      [tabIndex]="0"
    ></motif-progress-bar>
    <p progressbar-label>Chart of Account Mapping in progress...</p>

    <p
      class="cancel-run"
      [tabIndex]="0"
      (click)="cancelValidatedMappingRun()"
      (keydown.enter)="cancelValidatedMappingRun()"
    >
      Cancel
    </p>
  </div>
  }

  <div class="buttons-container">
    <motif-button
      variant="primary-alt"
      [disabled]="runCoAFinalMapLoading"
      (click)="goToPreviousStep(true)"
    >
      Go back
    </motif-button>
    <motif-button
      variant="primary"
      [disabled]="runCoAFinalMapLoading || coaFinalMappingFileFileHasError"
      (click)="runValidatedMapping()"
    >
      Continue
    </motif-button>
  </div>
  } @if(currentStep === 8){
  <div class="process-message-container" *ngIf="stepSevenDuration">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ stepSevenDuration }}</p>
  </div>

  <app-custom-motif-downloader
    [filename]="coaFinalMappedFileToDownload.filename"
    [fileId]="coaFinalMappedFileToDownload.id"
    [fileSize]="coaFinalMappedFileToDownload.file_size"
  ></app-custom-motif-downloader>

  <div class="buttons-container">
    <motif-button
      variant="primary-alt"
      (click)="goToPreviousStep(true)"
    >
      Go back
    </motif-button>
  </div>
  }
</div>
